export default __webpack_public_path__ + "images/box-icon-yellow.svg";